import { ColDef, ColGroupDef } from "ag-grid-community";
import { BasePermissionGrid } from "../Grids/PermissionGrids/BasePermissionGrid";
import { GridViewRole } from "../RolePanelTypes";

export class GridViewRolesGrid extends BasePermissionGrid<GridViewRole> {
    id: string = 'GridViewRoles';
    gridClass: string = 'gridViewRolesGrid';

    protected endpoint: string = '/rolePanel/gridViewRoles';

    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: 'Name', headerName: 'Grid View Name', flex: 2, resizable: false },
            {
                field: 'AllowView',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            }
        ];
    }
}